/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Cost_CentreInputs */

const en_reference_field_cost_centre = /** @type {(inputs: Reference_Field_Cost_CentreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost centre`)
};

/**
* | output |
* | --- |
* | "Cost centre" |
*
* @param {Reference_Field_Cost_CentreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_cost_centre = /** @type {((inputs?: Reference_Field_Cost_CentreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Cost_CentreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_cost_centre(inputs)
});